import { StyledImg } from "./SignatureBannerData.styles";
import BannerTeltecData from "assets/bannerTeltecData.png"
import { ToggleInput } from "components/ToggleInput";

type SignatureBannerDataProps = {
  customPhone: string;
  setCustomPhone: (phone: string) => void;
  showBanner?: boolean;
  showControls?: boolean;
};

export const SignatureBannerData = ({
  customPhone,
  setCustomPhone,
  showBanner = true,
  showControls = true,
}: SignatureBannerDataProps) => {

  const handleChange = (event: any) => {
    setCustomPhone(event.target.value);
  };

  return (
    <span>
      {showBanner ? (
        <a
          href="https://teltecdata.com.br/"
          rel="noopener noreferrer"
        >
          <StyledImg src={BannerTeltecData} />
        </a>
      ) : null}
      {showControls ? (
        <div data-no-copy="true">
          <ToggleInput type={"tel"} placeholder={"Digite o número do telefone"} value={customPhone} onChange={handleChange} />
        </div>
      ) : null}
    </span>
  );
};
